export const menubarHeaderDesignToken = {
	padding: '0 4.5rem 0 4.5rem',
	background: '{primary.950}',
	border: {
		radius: '0',
		color: '{primary.900}',
	},
	item: {
		color: 'white',
		padding: '0.5rem 0.85rem',
		borderRadius: '6px',
		focus: {
			color: 'white',
			background: '{primary.700}',
		},
		active: {
			color: 'white',
			background: '{primary.700}',
		},
	},
	mobile: {
		button: {
			color: 'white',
			hover: {
				background: '{primary.700}',
				color: 'white',
			},
		},
	},
	submenu: {
		background: '{primary.900}',
		item: {
			color: 'white',
			icon: {
				color: 'white',
			},
			focus: {
				background: '{primary.700}',
				color: 'white',
			},
		},
	},
};
